// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditTask-module__filesBox--ssGnJ {
    margin-top: 20px;
    
}

.EditTask-module__filesBox--ssGnJ>h4 {
    color: #0054E6;
    margin: 0 0 10px 0;

}

.EditTask-module__titleBox--mRph7 {
    display: flex;
    justify-content: space-between;
}

.EditTask-module__titleBox--mRph7>h1 {
    color: #6F879C;
    font-size: 30px;
    font-weight: 500;
}

.EditTask-module__btnBack--TXtaE {
    text-transform: none !important;
    color: #0054E6 !important;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 70px;
    gap: 10px;
}

.EditTask-module__formBox--3uqWz {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    border-radius: 14px;
    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    min-height: 50vh;
    background-color: white;
    overflow: hidden;
    width: 100%;
}

.EditTask-module__formContent--QdR25 {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 90%;
}

.EditTask-module__dataPicker--pdLlf,
.EditTask-module__dataPicker--pdLlf>div {
    height: 40px !important;
}

.EditTask-module__selectsBox--K3L47,
.EditTask-module__dopBox--Wuhym {
    display: flex;
    flex-direction: row;
    gap: 20px;
}

.EditTask-module__selectsBox--K3L47>div {
    width: 50%;
}

.EditTask-module__dopBox--Wuhym>div {
    width: 100%;
}

.EditTask-module__actionsBtnBox--kwbU8 {
    display: flex;
    gap: 20px;
    margin-top: 20px;
    justify-content: center;
}

@media (max-width: 1000px) {
    .EditTask-module__titleBox--mRph7 {
        flex-direction: column;
        justify-content: normal;
        align-items: normal;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/edit-task/EditTask.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;IACd,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,4DAA4D;IAC5D,yDAAyD;IACzD,oDAAoD;IACpD,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;AACJ","sourcesContent":[".filesBox {\r\n    margin-top: 20px;\r\n    \r\n}\r\n\r\n.filesBox>h4 {\r\n    color: #0054E6;\r\n    margin: 0 0 10px 0;\r\n\r\n}\r\n\r\n.titleBox {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.titleBox>h1 {\r\n    color: #6F879C;\r\n    font-size: 30px;\r\n    font-weight: 500;\r\n}\r\n\r\n.btnBack {\r\n    text-transform: none !important;\r\n    color: #0054E6 !important;\r\n    display: flex;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    height: 70px;\r\n    gap: 10px;\r\n}\r\n\r\n.formBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 30px;\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    min-height: 50vh;\r\n    background-color: white;\r\n    overflow: hidden;\r\n    width: 100%;\r\n}\r\n\r\n.formContent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    width: 90%;\r\n}\r\n\r\n.dataPicker,\r\n.dataPicker>div {\r\n    height: 40px !important;\r\n}\r\n\r\n.selectsBox,\r\n.dopBox {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 20px;\r\n}\r\n\r\n.selectsBox>div {\r\n    width: 50%;\r\n}\r\n\r\n.dopBox>div {\r\n    width: 100%;\r\n}\r\n\r\n.actionsBtnBox {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n    justify-content: center;\r\n}\r\n\r\n@media (max-width: 1000px) {\r\n    .titleBox {\r\n        flex-direction: column;\r\n        justify-content: normal;\r\n        align-items: normal;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filesBox": `EditTask-module__filesBox--ssGnJ`,
	"titleBox": `EditTask-module__titleBox--mRph7`,
	"btnBack": `EditTask-module__btnBack--TXtaE`,
	"formBox": `EditTask-module__formBox--3uqWz`,
	"formContent": `EditTask-module__formContent--QdR25`,
	"dataPicker": `EditTask-module__dataPicker--pdLlf`,
	"selectsBox": `EditTask-module__selectsBox--K3L47`,
	"dopBox": `EditTask-module__dopBox--Wuhym`,
	"actionsBtnBox": `EditTask-module__actionsBtnBox--kwbU8`
};
export default ___CSS_LOADER_EXPORT___;
